/**
 * Format work scope slug (e.g. "interior-paint") to display name (e.g. "Interior Paint").
 * Used for WO titles, list/detail views, and filters so all workscopes show consistently.
 */
export function formatWorkScope(workScope: string): string {
  if (!workScope) return workScope

  // Special case: M&G Crawl Space
  if (workScope.toLowerCase() === "m-and-g-crawl-space") {
    return "M&G Crawl Space"
  }

  // Special case: Alternative Ministry (DB slug alt-ministry; legacy alternative-ministry)
  const slug = workScope.toLowerCase()
  if (slug === "alternative-ministry" || slug === "alt-ministry") {
    return "Alternative Ministry"
  }

  return workScope
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}

/** True for Alternative Ministry work scopes (current and legacy slugs). */
export function isAlternativeMinistryWorkScope(
  workScope?: string | null,
): boolean {
  if (!workScope) return false
  const slug = workScope.toLowerCase()
  return slug === "alt-ministry" || slug === "alternative-ministry"
}
